@if (!readOnly) {
	<div class="session-config-search relative mb-4">
		<mat-form-field appearance="outline" class="form-field-sm">
			<input
				matInput
				[(ngModel)]="searchQuery"
				[ngModelOptions]="{ standalone: true }"
				placeholder="Search"
				class="pr-10"
			/>
			<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
		</mat-form-field>
	</div>
}

@if (sections.length) {
	<div class="grid grid-cols-4 gap-x-16 gap-y-3">
		@for (col of labeledColumns; track col.key) {
			<div>
				@if (col.showTitle) {
					<div class="mb-2 font-semibold">{{ col.title }}</div>
				} @else {
					<div class="mb-2">&nbsp;</div>
				}
				<div class="flex flex-col gap-3">
					@for (item of col.items; track item.code) {
						<ng-container
							*ngTemplateOutlet="sessionItem; context: { $implicit: item, section: col.source }"
						/>
					}
				</div>
			</div>
		}
	</div>
} @else {
	<div class="grid grid-cols-4 gap-x-16 gap-y-3">
		@for (col of gridColumns(); track col.columnIndex) {
			<div class="flex flex-col gap-3">
				@for (item of col.items; track item.code) {
					<ng-container *ngTemplateOutlet="sessionItem; context: { $implicit: item }" />
				}
			</div>
		}
	</div>
}

<ng-template #sessionItem let-item let-section="section">
	@if (item.selectionMode === "radio_group") {
		<div class="flex flex-col gap-2">
			<div class="text-sm font-medium">{{ item.description }}</div>
			<mat-radio-group
				class="flex flex-col gap-2 pl-2"
				[value]="selectedRadioChildCode(item, sessionsFor(section))"
				(change)="onRadioGroupChange(item, $event, sessionsFor(section))"
			>
				@for (child of item.children; track child.code) {
					<mat-radio-button color="primary" [value]="child.code" [disabled]="readOnly">
						{{ child.description }}
					</mat-radio-button>
				}
			</mat-radio-group>
		</div>
	} @else {
		<div class="flex flex-col gap-1">
			@if (sessionsFor(section).get(item.code); as sessionCtrl) {
				<mat-checkbox [formControl]="$any(sessionCtrl)" color="primary" [disabled]="readOnly">
					{{ item.description }}
				</mat-checkbox>
			}
			@if (showRadioChildren(item, sessionsFor(section))) {
				<mat-radio-group
					class="flex flex-col gap-2 pl-6"
					[value]="selectedRadioChildCode(item, sessionsFor(section))"
					(change)="onRadioGroupChange(item, $event, sessionsFor(section))"
				>
					@for (child of item.children; track child.code) {
						<mat-radio-button color="primary" [value]="child.code" [disabled]="readOnly">
							{{ child.description }}
						</mat-radio-button>
					}
				</mat-radio-group>
				@if (showRadioRequiredError(item, sessionsFor(section))) {
					<div class="pl-6 text-sm text-red">Please select one option for {{ item.description }}.</div>
				}
			}
			@if (showRemarkRow(item, sessionsFor(section), optionalRemarksFor(section))) {
				<div class="pl-6 text-sm">
					@if (getRemarkPreview(item.code, remarksFor(section))) {
						<span class="text-grey-90">{{ getRemarkPreview(item.code, remarksFor(section)) }}</span>
					} @else {
						<span class="italic text-grey-60">No details added</span>
					}
					@if (!readOnly) {
						<button
							type="button"
							class="ml-2 cursor-pointer border-0 bg-transparent p-0 text-sm text-red underline"
							(click)="openRemarkEditor(item, remarksFor(section))"
						>
							Edit @if (item.requiresText) {
								<span class="text-red">*</span>
							}
						</button>
					}
					@if (showRemarkRequiredError(item.code, remarksFor(section))) {
						<div class="mt-1 text-sm text-red">Please enter details for {{ item.description }}.</div>
					}
				</div>
			}
		</div>
	}
</ng-template>
